/**
 * Sustituya a loadScriptAsync o loadScript
 * @param {String} url La url de la librería a cargar
 * @returns Una promesa de cada carga de la librería
 */
export function loadLib(url, idTag) {
	setTimeout(() => {
		return new Promise((resolve, reject) => {
			globalThis.idTagDelio = idTag;
			const script = document.createElement('script');
			script.src = url;
			script.async = true;
			script.onload = () => {
				resolve(); // Carga
			};
			script.onerror = reject; // No carga
			document.head.appendChild(script);
		});
	}, 500);
}
/**
 *
 * @param {Array} libs Array de objetos con las librerías a cargar
 */
export async function loadAllLibs(libs) {
	try {
		const promises = libs.map((lib) => loadLib(lib.url));
		await Promise.all(promises);
		return promises;
	} catch (error) {
		console.error(error);
	}
}

export const getLeadId = () => {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			if (globalThis.Piwik) {
				// @ts-ignore
				clearInterval();
				const idVisitor =
					globalThis.Piwik.getAsyncTracker().getVisitorId();
				resolve(idVisitor);
			} else {
				reject(new Error('Piwik no existe '));
			}
		}, 1000);
	});
};
